import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-disclosure-notice',
    templateUrl: './disclosure-notice.component.html',
    styleUrls: ['./disclosure-notice.component.scss'],
    standalone: false
})
export class DisclosureNoticeComponent
  implements OnInit, OnDestroy
{
  @Input() disclosureType: any;
  @Input() disclosure: any;
  private unsubscribe$ = new Subject<void>();
  policyPDFDisclosureNotice: any[] = [];

  constructor() {
   
  }

  ngOnInit(): void {

    if (this.disclosure){
      this.policyPDFDisclosureNotice = this.preparePDFDisclosureNotice(this.disclosure);
    }

  }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes.disclosure.currentValue){
      this.policyPDFDisclosureNotice = this.preparePDFDisclosureNotice(changes.disclosure.currentValue);
    }

}
  private preparePDFDisclosureNotice(disclosure: any[]): any[] {
    return (disclosure || []).map(insurer => ({
      ...insurer,
      insuranceParsed: this.parseObject(insurer?.insurance),
      claimsParsed: this.parseObject(insurer?.claims)?.[0]?.dr ?? [],
      complaintsParsed: this.parseObject(insurer?.complaints),
      conflictDisclosureParsed: this.parseObject(insurer?.conflict_disclosure),
    }));
  }

  parseObject(parseObj: any): any {
    try {
      return JSON.parse(parseObj);
    } catch (e) {
      // console.error('error: ', e);
    }
    return [];
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
